const getPipeHeaderConfig = (variant) => {
  const variantsConfigs = {
    defaultConfig: [
      { path: "/01-step/" },
      { path: "/02-step/" },
      { path: "/03-step/" },
      { path: "/04-step/" },
      { path: "/05-step/" },
      { path: "/06-step/" },
      { path: "/07-step/" },
      { path: "/08-step/" },
      { path: "/09-step/" },
      { path: "/10-step/" },
      { path: "/11-step/" },
      { path: "/12-step/" },
      { path: "/13-step/" },
      { path: "/14-step/" },
      { path: "/15-step/" },
      { path: "/16-step/" },
      { path: "/17-step/" },
      { path: "/18-step/" },
      { path: "/19-step/" },
      { path: "/20-step/" },
      { path: "/21-step/" },
      { path: "/22-step/" },
      { path: "/23-step/" },
      { path: "/24-step/" },
      { path: "/25-step/" },
      { path: "/26-step/" },
      { path: "/27-step/" },
      { path: "/28-step/" },
      { path: "/29-step/" },
      { path: "/30-step/" },
      { path: "/31-step/" },
      { path: "/32-step/" },
    ],
    "L1 Primary": [
      { path: "/ageRange/" },
      { path: "/stepAgeRange/" },
      { path: "/stepPrimaryGoal/" },
      { path: "/stepSocialProofWithReviews/" },
      { path: "/stepName/" },
      { path: "/stepCurrentBodyShape/" },
      { path: "/stepDietFamiliarity/" },
      { path: "/stepFastingIntro/" },
      { path: "/stepDailyHungerTime/" },
      { path: "/stepBreakfastTime/" },
      { path: "/stepLunchTime/" },
      { path: "/stepDinnerTime/" },
      { path: "/stepMealPreparation/" },
      { path: "/stepWeeklyActivityLevel/" },
      { path: "/stepWorkingHours/" },
      { path: "/stepDailyActivityLevel/" },
      { path: "/stepSecondaryGoal/" },
      { path: "/stepEncouragementWithCommunityNumbers/" },
      { path: "/stepExactAge/" },
      { path: "/stepHeight/" },
      { path: "/stepCurrentWeight/" },
      { path: "/stepGoalWeight/" },
      { path: "/stepProjectedProgressGraph/" },
      { path: "/stepSocialProofWithTestimonial/" },
      { path: "/stepDailyWalkingTime/" },
      { path: "/stepSleepHours/" },
      { path: "/stepCurrentWeightLossPractices/" },
      { path: "/stepDailyWaterIntake/" },
      { path: "/stepSupplementAndMedicationUsage/" },
      { path: "/stepHealthConditions/" },
      { path: "/stepEncouragementWithHonestyAppreciation/" },
      { path: "/stepUpdatedProjectedProgressGraph/" },
      { path: "/stepPlanGeneration/" },
      { path: "/stepEmailCapture/" },
      { path: "/stepRhetoricalQuestion1/" },
      { path: "/stepRhetoricalQuestion2/" },
      { path: "/stepRhetoricalQuestion3/" },
      { path: "/stepEncouragementAllSet/" },
      { path: "/stepPersonalCommitment/" },
      { path: "/stepResultsProgressGraph/" },
      { path: "/stepResultsBmi/" },
      { path: "/stepResultsHealthImprovements/" },
      { path: "/stepResultsSocialProofAndGuidance/" },
      { path: "/stepResultsStartNow/" },
    ],
    "Water Fasting": [
      { path: "/ageRange/" },
      { path: "/stepAgeRange/" },
      { path: "/stepPrimaryGoal/" },
      { path: "/stepSocialProofWithReviews/" },
      { path: "/stepName/" },
      { path: "/stepCurrentBodyShape/" },
      { path: "/stepDietFamiliarity/" },
      { path: "/stepFastingIntro/" },
      { path: "/stepDailyHungerTime/" },
      { path: "/stepBreakfastTime/" },
      { path: "/stepLunchTime/" },
      { path: "/stepDinnerTime/" },
      { path: "/stepMealPreparation/" },
      { path: "/stepWeeklyActivityLevel/" },
      { path: "/stepWorkingHours/" },
      { path: "/stepDailyActivityLevel/" },
      { path: "/stepSecondaryGoal/" },
      { path: "/stepEncouragementWithCommunityNumbers/" },
      { path: "/stepExactAge/" },
      { path: "/stepHeight/" },
      { path: "/stepCurrentWeight/" },
      { path: "/stepGoalWeight/" },
      { path: "/stepProjectedProgressGraph/" },
      { path: "/stepSocialProofWithTestimonial/" },
      { path: "/stepDailyWalkingTime/" },
      { path: "/stepSleepHours/" },
      { path: "/stepCurrentWeightLossPractices/" },
      { path: "/stepDailyWaterIntake/" },
      { path: "/stepEncouragementWaterFasting/" },
      { path: "/stepSupplementAndMedicationUsage/" },
      { path: "/stepHealthConditions/" },
      { path: "/stepEncouragementWithHonestyAppreciation/" },
      { path: "/stepUpdatedProjectedProgressGraph/" },
      { path: "/stepPlanGeneration/" },
      { path: "/stepEmailCapture/" },
      { path: "/stepRhetoricalQuestion1/" },
      { path: "/stepRhetoricalQuestion2/" },
      { path: "/stepRhetoricalQuestion3/" },
      { path: "/stepEncouragementAllSet/" },
      { path: "/stepPersonalCommitment/" },
      { path: "/stepResultsProgressGraph/" },
      { path: "/stepResultsBmi/" },
      { path: "/stepResultsHealthImprovements/" },
      { path: "/stepResultsSocialProofAndGuidance/" },
      { path: "/stepResultsStartNow/" },
    ],
    "WF Discount Code": [
      { path: "/ageRange/" },
      { path: "/stepAgeRange/" },
      { path: "/stepPrimaryGoal/" },
      { path: "/stepSocialProofWithReviews/" },
      { path: "/stepName/" },
      { path: "/stepCurrentBodyShape/" },
      { path: "/stepDietFamiliarity/" },
      { path: "/stepFastingIntro/" },
      { path: "/stepDailyHungerTime/" },
      { path: "/stepBreakfastTime/" },
      { path: "/stepLunchTime/" },
      { path: "/stepDinnerTime/" },
      { path: "/stepMealPreparation/" },
      { path: "/stepWeeklyActivityLevel/" },
      { path: "/stepWorkingHours/" },
      { path: "/stepDailyActivityLevel/" },
      { path: "/stepSecondaryGoal/" },
      { path: "/stepEncouragementWithCommunityNumbers/" },
      { path: "/stepExactAge/" },
      { path: "/stepHeight/" },
      { path: "/stepCurrentWeight/" },
      { path: "/stepGoalWeight/" },
      { path: "/stepProjectedProgressGraph/" },
      { path: "/stepSocialProofWithTestimonial/" },
      { path: "/stepDailyWalkingTime/" },
      { path: "/stepSleepHours/" },
      { path: "/stepCurrentWeightLossPractices/" },
      { path: "/stepDailyWaterIntake/" },
      { path: "/stepEncouragementWaterFasting/" },
      { path: "/stepSupplementAndMedicationUsage/" },
      { path: "/stepHealthConditions/" },
      { path: "/stepEncouragementWithHonestyAppreciation/" },
      { path: "/stepUpdatedProjectedProgressGraph/" },
      { path: "/stepPlanGeneration/" },
      { path: "/stepEmailCapture/" },
      { path: "/stepRhetoricalQuestion1/" },
      { path: "/stepRhetoricalQuestion2/" },
      { path: "/stepRhetoricalQuestion3/" },
      { path: "/stepEncouragementAllSet/" },
      { path: "/stepPersonalCommitment/" },
      { path: "/stepResultsProgressGraph/" },
      { path: "/stepResultsBmi/" },
      { path: "/stepResultsHealthImprovements/" },
      { path: "/stepResultsSocialProofAndGuidance/" },
      { path: "/stepResultsStartNow/" },
      { path: "/stepRevealDiscount/" },
    ],
  }

  return variantsConfigs[variant] || variantsConfigs.defaultConfig
}

export default getPipeHeaderConfig
